import { SearchTotal } from '@aibees/elephant/components/search-total';
import { ViewRecordsPopover } from '@aibees/elephant/components/view-record-button/view-records-popover';
import { useDataViewChartView } from '@aibees/elephant/context/data-view-context';
import { SearchParamsParamsProvider } from '@aibees/elephant/context/search-params-params-provider';
import { classnames } from '@aibees/shared/utils';
import { memo, Suspense, useEffect, useMemo, useState } from 'react';
import { DataTypeProvider } from '../search-data-visualization/components/data-type-toggle/data-type-context';
import { MapViewProvider } from '../search-data-visualization/context/map-view-context';
import OutsideClickHandler from '../search-table-company/outside-click-handler';
import { config } from './config';
import { useGetPeopleSearchTableColumns } from './hooks/use-get-people-search-table-columns';
import { useUpdatePeopleSearchItems } from './hooks/use-update-people-search-items';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchTablePeopleProps as Props } from './types';

const searchTotalEl = <SearchTotal />;

export const SearchTablePeople = memo(({ className }: Props) => {
  useUpdatePeopleSearchItems();
  const columns = useGetPeopleSearchTableColumns(config);
  const [SearchDataVisualization, setSearchDataVisualization] =
    useState<React.FC | null>(null);

  const { isChartView } = useDataViewChartView();

  useEffect(() => {
    if (isChartView) {
      import('@aibees/elephant/feature/search-data-visualization')
        .then((module) =>
          setSearchDataVisualization(() => module.SearchDataVisualization)
        )
        .catch((error) =>
          console.error('Error loading SearchDataVisualization:', error)
        );
    }
  }, [isChartView]);

  const tableConfig = useMemo(() => ({ ...config, columns }), [columns]);

  return (
    <OutsideClickHandler>
      <ViewRecordsPopover />

      <SearchParamsParamsProvider>
        <Styled.Wrapper
          className={classnames('SearchTablePeople', className, {
            isChartView,
          })}
          sx={SX.root}
          config={tableConfig}
          beforeEl={searchTotalEl}
        />
      </SearchParamsParamsProvider>
      {isChartView && SearchDataVisualization && (
        <Suspense>
          <DataTypeProvider>
            <MapViewProvider>
              <SearchDataVisualization />
            </MapViewProvider>
          </DataTypeProvider>
        </Suspense>
      )}
    </OutsideClickHandler>
  );
});

SearchTablePeople.displayName = 'SearchTablePeople';
